"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reqrepov3PatientDtoToJSON = exports.Reqrepov3PatientDtoFromJSONTyped = exports.Reqrepov3PatientDtoFromJSON = exports.instanceOfReqrepov3PatientDto = exports.Reqrepov3PatientDtoGenderEnum = exports.Reqrepov3PatientDtoEthnicityEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.Reqrepov3PatientDtoEthnicityEnum = {
    Unknown: 'Unknown',
    AshkenaziJewish: 'Ashkenazi Jewish',
    Asian: 'Asian',
    BlackAfricanAmerican: 'Black/African-American',
    FrenchCanadian: 'French Canadian',
    Hispanic: 'Hispanic',
    Mediterranean: 'Mediterranean',
    NativeAmerican: 'Native American',
    PacificIslander: 'Pacific Islander',
    SephardicJewish: 'Sephardic Jewish',
    WhiteCaucasian: 'White/Caucasian',
    Other: 'Other'
};
/**
 * @export
 */
exports.Reqrepov3PatientDtoGenderEnum = {
    Unknown: 'Unknown',
    Male: 'Male',
    Female: 'Female'
};
/**
 * Check if a given object implements the Reqrepov3PatientDto interface.
 */
function instanceOfReqrepov3PatientDto(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfReqrepov3PatientDto = instanceOfReqrepov3PatientDto;
function Reqrepov3PatientDtoFromJSON(json) {
    return Reqrepov3PatientDtoFromJSONTyped(json, false);
}
exports.Reqrepov3PatientDtoFromJSON = Reqrepov3PatientDtoFromJSON;
function Reqrepov3PatientDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'age': !(0, runtime_1.exists)(json, 'age') ? undefined : json['age'],
        'dob': !(0, runtime_1.exists)(json, 'dob') ? undefined : json['dob'],
        'deceased': !(0, runtime_1.exists)(json, 'deceased') ? undefined : json['deceased'],
        'deceasedDate': !(0, runtime_1.exists)(json, 'deceasedDate') ? undefined : json['deceasedDate'],
        'ethnicity': !(0, runtime_1.exists)(json, 'ethnicity') ? undefined : json['ethnicity'],
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'gender': !(0, runtime_1.exists)(json, 'gender') ? undefined : json['gender'],
        'genderIdentity': !(0, runtime_1.exists)(json, 'genderIdentity') ? undefined : json['genderIdentity'],
        'mrn': !(0, runtime_1.exists)(json, 'mrn') ? undefined : json['mrn'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'duplicateIds': !(0, runtime_1.exists)(json, 'duplicateIds') ? undefined : json['duplicateIds'],
        'father': !(0, runtime_1.exists)(json, 'father') ? undefined : json['father'],
        'mother': !(0, runtime_1.exists)(json, 'mother') ? undefined : json['mother'],
        'patientRelationship': !(0, runtime_1.exists)(json, 'patientRelationship') ? undefined : json['patientRelationship'],
        'relationshipToProband': !(0, runtime_1.exists)(json, 'relationshipToProband') ? undefined : json['relationshipToProband'],
        'truePatient': !(0, runtime_1.exists)(json, 'true_patient') ? undefined : json['true_patient'],
    };
}
exports.Reqrepov3PatientDtoFromJSONTyped = Reqrepov3PatientDtoFromJSONTyped;
function Reqrepov3PatientDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'age': value.age,
        'dob': value.dob,
        'deceased': value.deceased,
        'deceasedDate': value.deceasedDate,
        'ethnicity': value.ethnicity,
        'id': value.id,
        'gender': value.gender,
        'genderIdentity': value.genderIdentity,
        'mrn': value.mrn,
        'name': value.name,
        'duplicateIds': value.duplicateIds,
        'father': value.father,
        'mother': value.mother,
        'patientRelationship': value.patientRelationship,
        'relationshipToProband': value.relationshipToProband,
        'true_patient': value.truePatient,
    };
}
exports.Reqrepov3PatientDtoToJSON = Reqrepov3PatientDtoToJSON;
